import { useMemo, useState, useEffect } from 'react';
import Image from 'next/image';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import NoImage from '@/customercenter-ui/icons/noImage';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { getCookieValue } from '@/helpers/utils/siteUtils';
import { COOKIE_KEYS } from '../../../../constants/constant';

interface ImageProps {
  className?: string;
  alt?: string;
  src: string;
  quality?: string;
  imageWidth: number;
  imageHeight: number;
  fullWidth?: boolean;
  onClick?: any;
  loading?: any;
  loadPriority?: boolean;
  showQuality?: boolean;
  showDpr?: boolean;
}

const ContentStackImage: React.FC<ImageProps> = ({
  className,
  alt = '',
  src,
  quality = 'medium',
  imageWidth,
  imageHeight,
  fullWidth = false,
  onClick = () => {},
  loading = 'eager',
  loadPriority,
  showDpr = true,
}) => {
  const projectSettings: ProjectSettings = useProjSettings();
  const [noImageActive, setNoImageActive] = useState(false);
  const [divisionCode, setDivisionCode] = useState<string>();

  useEffect(() => {
    const divisionCode = getCookieValue(COOKIE_KEYS.selectedSite)?.slice(0, 2) ?? '';
    setDivisionCode(divisionCode);
  }, []);

  const imageLoader = ({ src = '' }) => {
    return src;
  };
  const sourceQuality = () => {
    switch (quality) {
      case 'high':
        return 100;
      case 'medium':
        return 75;
      case 'low':
        return 50;
    }
  };
  const onImageError = () => {
    setNoImageActive(true);
  };
  const host = divisionCode && JSON.parse(projectSettings?.imageHost ?? '')[divisionCode];

  const getSource = useMemo(() => {
    const finalSRC = src?.match(/^https:\/\/images\.contentstack\.io([^'"]*)/)
      ? src?.replace(/^https:\/\/images\.contentstack\.io([^'"]*)/, host + '$1')
      : src?.match(/^http/)
      ? src
      : host + src;
    setNoImageActive(false);
    const dprParam = showDpr ? '&dpr=1.5' : '';
    return finalSRC && finalSRC.indexOf('?') > -1
      ? finalSRC + '&quality=' + sourceQuality() + '&width=' + imageWidth + dprParam
      : finalSRC + '?quality=' + sourceQuality() + '&width=' + imageWidth + dprParam;
  }, [src, host]);

  return !noImageActive && host ? (
    <Image
      onClick={onClick}
      className={className}
      src={getSource}
      alt={alt}
      width={imageWidth}
      height={imageHeight}
      loader={imageLoader}
      onError={onImageError}
      loading={loading}
      style={{ width: fullWidth ? '100%' : imageWidth, height: fullWidth ? '100%' : imageHeight }}
      priority={loadPriority}
    />
  ) : (
    <NoImage className={className} width={fullWidth ? '100%' : imageWidth} height={fullWidth ? '100%' : imageHeight} />
  );
};

export default ContentStackImage;
